module.exports = __webpack_public_path__ + "static/media/rsz_banner_slider4.eb5877e0.jpg";